export default "__VITE_PUBLIC_ASSET__75388cbb__"